import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
// @ts-expect-error Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "LineItemTax__StyledDiv"
})(["white-space:-o-pre-wrap;"]);
const LineItemTax = ({
  currencyCode,
  areTaxLabelsDifferent,
  label,
  taxAmount
}) => {
  const taxAmountAndLabel = useMemo(() => {
    if (taxAmount && label) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.lineItems.taxAmountAndLabel_jsx",
        options: {
          value: taxAmount,
          currencyCode,
          label
        },
        elements: {
          Price: FormattedIntlCurrency
        }
      });
    } else if (!areTaxLabelsDifferent && label) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.lineItems.zeroTaxAmountAndLabel",
        options: {
          currencySymbol: getNativeCurrencySymbol(currencyCode),
          label
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.lineItems.zeroTaxAmount",
      options: {
        currencySymbol: getNativeCurrencySymbol(currencyCode)
      }
    });
  }, [currencyCode, label, taxAmount, areTaxLabelsDifferent]);
  return /*#__PURE__*/_jsx(StyledDiv, {
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      as: "small",
      "data-test-id": "line-item-tax",
      children: taxAmountAndLabel
    })
  });
};
export default LineItemTax;